module.exports = __webpack_public_path__ + "static/media/page_15.904cdff0.jpg";